import React from 'react';
import { ClipboardCheck, Car, FileText, TrendingUp, Key, ArrowRight } from 'lucide-react';
import { howWeDoItData } from '../../data/mock';

const iconMap = {
  ClipboardCheck,
  Car,
  FileText,
  TrendingUp,
  Key
};

const HowWeDoIt = () => {
  return (
    <section id="how" className="py-20 lg:py-32 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-[#63E61E]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-[#63E61E]/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-[#63E61E]/10 rounded-full mb-4">
            <span className="text-[#63E61E] font-bold text-sm tracking-wide">NUESTRO PROCESO</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
            {howWeDoItData.title}
          </h2>
          <p className="text-lg text-gray-700">{howWeDoItData.description}</p>
        </div>

        {/* Steps - Diseño de Timeline */}
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Línea vertical en móvil, horizontal en desktop */}
            <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-[#63E61E]/20 via-[#63E61E] to-[#63E61E]/20 transform -translate-y-1/2"></div>
            
            {/* Steps Grid */}
            <div className="grid lg:grid-cols-5 gap-8 lg:gap-4">
              {howWeDoItData.steps.map((step, index) => {
                const IconComponent = iconMap[step.icon];
                return (
                  <div key={index} className="relative">
                    {/* Paso */}
                    <div className="flex flex-col items-center text-center">
                      {/* Número y círculo */}
                      <div className="relative mb-6">
                        <div className="w-24 h-24 bg-gradient-to-br from-[#63E61E] to-[#52c518] rounded-full flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300 relative z-10">
                          <div className="absolute -top-3 -right-3 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg border-2 border-[#63E61E]">
                            <span className="text-xl font-black text-gray-900">{step.number}</span>
                          </div>
                          <IconComponent className="w-10 h-10 text-white" />
                        </div>
                        
                        {/* Flecha entre pasos (solo desktop) */}
                        {index < howWeDoItData.steps.length - 1 && (
                          <div className="hidden lg:block absolute top-1/2 left-full w-full transform -translate-y-1/2">
                            <ArrowRight className="w-6 h-6 text-[#63E61E] mx-auto" />
                          </div>
                        )}
                      </div>
                      
                      {/* Contenido */}
                      <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100">
                        <h3 className="text-lg font-bold text-gray-900 mb-3">
                          {step.title}
                        </h3>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 text-gray-700">
            <div className="h-1 w-8 bg-[#63E61E]"></div>
            <p className="text-lg font-semibold">Un proceso simple, transparente y efectivo</p>
            <div className="h-1 w-8 bg-[#63E61E]"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeDoIt;